export const createSampleCard = (num = 1) => ({
  order: num,
  title: `Title ${num}`,
  html: `<p>Reinforced concrete was invented in 1849 by Joseph Monier.</p>`
})
